import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';

const useUpdateAffiliateDetail = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('updateAffiliateDetails', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: ['affiliates'] });
      await navigate({ to: '/users/affiliates' });
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync, isPending };
};

export default useUpdateAffiliateDetail;
